package com.sddamico.draftmachine.components.layouts

import androidx.compose.runtime.Composable
import com.sddamico.draftmachine.ds.dmGridBackdrop
import com.sddamico.draftmachine.ds.displayFlex
import com.sddamico.draftmachine.ds.motion.TransitionRole
import com.sddamico.draftmachine.ds.motion.transitionRole
import com.varabyte.kobweb.compose.css.JustifyContent
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.Div

/**
 * The app shell's centered content column. Phone-width (430px) on mobile; widens to 800px at the
 * [Breakpoint.MD] desktop threshold (≥768px). Owns the responsive max-width so every screen that
 * renders through [MobileFrame] switches between the mobile and desktop layouts together.
 */
val AppFrameColumnStyle = CssStyle {
  base { Modifier.fillMaxWidth().maxWidth(430.px).minHeight(100.vh) }
  Breakpoint.MD { Modifier.maxWidth(800.px) }
}

/**
 * The shared app shell — a full-viewport dark grid backdrop centering the [AppFrameColumnStyle]
 * content column (430px on mobile, 800px on desktop). [header] renders above [content] inside that
 * column; [modifier] is applied to the column itself (e.g. extra positioning or centering).
 */
@Composable
fun MobileFrame(
  modifier: Modifier = Modifier,
  header: (@Composable () -> Unit)? = null,
  content: @Composable () -> Unit,
) {
  Div(
    attrs = Modifier.fillMaxWidth().minHeight(100.vh).dmGridBackdrop()
      .displayFlex().justifyContent(JustifyContent.Center).toAttrs()
  ) {
    Div(
      attrs = AppFrameColumnStyle.toModifier().transitionRole(TransitionRole.Page).then(modifier).toAttrs()
    ) {
      header?.invoke()
      content()
    }
  }
}
